import { PublicClientApplication } from '@azure/msal-browser'

import { getMsalConfig } from '@/lib/msal/msal-config'

export class MsalClient {
  private static application: PublicClientApplication | null = null

  static getInstance(): PublicClientApplication {
    if (!MsalClient.application) {
      MsalClient.application = new PublicClientApplication(getMsalConfig())
    }

    return MsalClient.application
  }
}
